import { render, staticRenderFns } from "./complain.vue?vue&type=template&id=b237bb74&"
import script from "./complain.vue?vue&type=script&lang=js&"
export * from "./complain.vue?vue&type=script&lang=js&"
import style0 from "./complain.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports